import { CheckCircle } from "lucide-react";

const RXTAudioCapabilities = () => {
  const audioCapabilities = [
    {
      title: "Professional Audio Processing",
      items: [
        "Dante™/AES67 audio networking across all models",
        "SmartSpeak™ beamforming with dedicated 800MHz DSP on all models",
        "Feedback suppression, auto gain, and noise cancellation",
        "Mix-minus audio processing for clear communication",
        "Assistive hearing and translation talkback support"
      ]
    },
    {
      title: "WordGate™ Camera Integration",
      items: [
        "AI-powered speech intelligibility detection in 100+ languages",
        "Sound Pressure Level (SPL) analysis for accurate triggering",
        "Eliminates false triggers from clapping, coughing, and other noises",
        "Automatic camera preset activation based on active speaker",
        "Available on all RXT-4D, RXT-4DV, RXT-6D, and RXT-6DV models"
      ]
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Audio Capabilities</h2>
      <div className="grid gap-6 md:grid-cols-2">
        {audioCapabilities.map((capability, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border shadow-sm">
            <h3 className="text-lg font-semibold mb-3 text-[#069E50]">{capability.title}</h3>
            <ul className="space-y-2">
              {capability.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RXTAudioCapabilities;
